import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-activating-org-dialog',
  imports: [
    MatButtonModule, 
    MatDialogModule
  ],
  templateUrl: './error-activating-org-dialog.component.html',
  styleUrl: './error-activating-org-dialog.component.scss'
})
export class ErrorActivatingOrgDialogComponent implements OnInit {

  organizationId: number = 0;
  requiredPolicyOrPackage: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ErrorActivatingOrgDialogComponent>
  ) { }

  ngOnInit() {
    this.organizationId = this.data.organizationId;
    this.requiredPolicyOrPackage = this.data.orgMissingComponents;
  }
}